import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles(() => ({
	number: {
		whiteSpace: "nowrap",
	},
}));

const NoTariffsInfo = (props) => {
	const { ratesMobile, beautifulNumber, text } = props;
	const classes = useStyles();
	if (ratesMobile) {
		return (
			<div>
				{text.TARIFF_SEARCH_FAIL_1}
				<span className={classes.number}>{text.TARIFF_SEARCH_FAIL_2}</span>
				{text.TARIFF_SEARCH_FAIL_3}
			</div>
		);
	} else if (beautifulNumber) {
		return <div>{text.phones_beautiful_fail}</div>;
	}
};

export default NoTariffsInfo;
